import { render } from "./LbrxBookingSecondTheme.vue?vue&type=template&id=24ae28d2&scoped=true"
import script from "./LbrxBookingSecondTheme.vue?vue&type=script&lang=js"
export * from "./LbrxBookingSecondTheme.vue?vue&type=script&lang=js"

import "./LbrxBookingSecondTheme.vue?vue&type=style&index=0&id=24ae28d2&scoped=true&lang=css"
import "./LbrxBookingSecondTheme.vue?vue&type=style&index=1&id=24ae28d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ae28d2"]])

export default __exports__